(function () {
  var scrollToReviews = function () {
    var reviews = document.querySelector(".junup-product-review-wrapper .junip-product-review");
    const yOffset = -100;
    const y = reviews.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };
  var reviewsWrapper = document.querySelector(".junip-wrapper");
  if (reviewsWrapper) {
    reviewsWrapper.addEventListener("click", scrollToReviews, false);
    reviewsWrapper.addEventListener("touchend", scrollToReviews, false);
  }
})();

// recharge widget editing
(function () {

  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
 
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  // wait until recharge widget is loaded
  // waitForElm("[data-label-subsave]").then(function(elm){

  //   window.ReChargeWidget.destroyAllWidgets();

  // });

  // initialize mobile carousel for PDP content test 

  if ($(window).width() < 480) {
    $('.people_love_them .slider_mobile_only').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "draggable": true,
      "prevNextButtons": false,
      "wrapAround": true,
      "pageDots": true,
      "contain": true,
      "freeScroll": false,
      "initialIndex": 0
    });
  }



})();


// Junip anchor filtering
// example: 
// https://theearthlingco.com/products/shampoo-bars?filter_sort=most helpful&filter_hairtype=wavy_fine_flatter_s_shape&filter_hairconcern=frizz&filter_rating=5&filter_media=true
// ?filter_sort=mostHelpful&filter_hairtype=Wavy%20(Fine/Flatter%20S-Shape)&filter_concern=frizz&filter_rating=4
// ?filter_sort=mostHelpful&filter_hairtype=Wavy%20(Fine/Flatter%20S-Shape)&filter_hairconcern=frizz&filter_rating=4

(function () {
  document.addEventListener("junip-app-loaded", function () {
    let junipFiltersSort = document.querySelector('#junipReviewSort');
    let junipFiltersHairType = document.querySelector('#junipAttribute-560');
    let junipFiltersHairConcern = document.querySelector('#junipAttribute-561');
    let junipFiltersSkinType = document.querySelector('#junipAttribute-1071');
    let junipFiltersSkinConcern = document.querySelector('#junipAttribute-1070');
    let junipFiltersRating = document.querySelector('#junipRatingFilter');
    let junipFiltersMedia = document.querySelector('.junip-checkbox input');

    var params = (function (a) {
      if (a == "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
          b[p[0]] = "";
        else
          b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
      return b;
    })(window.location.search.substr(1).split('&'));

    let applyFilter = function (targetSelect, value) {
      setTimeout(function () {
        targetSelect.value = value;
        targetSelect.dispatchEvent(new Event('change', { 'bubbles': true }))
      }, 200);
    }

    Object.entries(params).forEach(([key, value]) => {
      if (key.includes('filter')) {
        console.log(`${key}: ${value}`);
        if (key.includes('sort')) {
          applyFilter(junipFiltersSort, value)
        } else if (key.includes('hairtype')) {
          applyFilter(junipFiltersHairType, value)
        } else if (key.includes('hairconcern')) {
          applyFilter(junipFiltersHairConcern, value)
        } else if (key.includes('skinconcern')) {
          applyFilter(junipFiltersSkinConcern, value)
        } else if (key.includes('skintype')) {
          applyFilter(junipFiltersSkinType, value)
        } else if (key.includes('rating')) {
          applyFilter(junipFiltersRating, value)
        } else if (key.includes('media')) {
          applyFilter(junipFiltersMedia, value)
        }
      }
    });
  });
})();

// check if needed and get HTML from
(function () {

  let reploSectionBelowDescription = document.querySelector('.replo-section-below-description');

  if (reploSectionBelowDescription) {
    let targetReploPage = document.querySelector('.replo-section-below-description').getAttribute('data-target-replo-page');

    fetch('/pages/' + targetReploPage).then(function (response) {
      // The API call was successful!
      return response.text();
    }).then(function (html) {

      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Get the image file
      var reploSection = doc.querySelector('#replo-fullpage-element');

      reploSectionBelowDescription.appendChild(reploSection);

    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  }


})();




document.addEventListener("DOMContentLoaded", (event) => {
  // Lightweight logger gated by window.igDebug
  const igLog = (...args) => { if (window.igDebug) try { console.log(...args); } catch(e) {} };
  refreshAddToCartButtonPrice();
  // --- Ensure upsell prices are included after upsell cards are rendered ---
  setTimeout(refreshAddToCartButtonPrice, 300);

  var sellingPlanContainer = document.querySelector('.selling-plan-fieldset');
  if (!sellingPlanContainer) {
    // For non-subscription products, watch for variant changes
    let productForm = document.querySelector('.shopify-product-form');
    if (productForm) {
      productForm.addEventListener('change', function() {
        refreshAddToCartButtonPrice();
      });
    }
    return;
  }

  var product = JSON.parse(sellingPlanContainer.dataset.product);
  var productForm = document.querySelector('.shopify-product-form');
  let sellingPlanCustom = document.querySelector('[name="selling_plan"]');

  // Prevent re-entrancy when programmatically toggling purchase options
  let _igHandlingSubscription = false;

  // Function to handle subscription state
  function handleSubscriptionState() {
    if (_igHandlingSubscription) return;
    _igHandlingSubscription = true;
    var selectedVariant = findSelectedVariant();
    var availableSellingPlanAllocations = selectedVariant?.selling_plan_allocations;
    const subWrapper = document.querySelector('.subscription_wrapper');
    const subscrInput = document.querySelector('#subscr');
    const otpInput = document.querySelector('#one_time');
    const planSelect = document.querySelector('#subscr_select');

    if (availableSellingPlanAllocations && availableSellingPlanAllocations.length > 0) {
      // Enable subscription input
      if (subscrInput) subscrInput.disabled = false;

      // Show/hide subscription_wrapper based on which purchase option is selected
      if (subWrapper) {
        if (subscrInput && subscrInput.checked) {
          subWrapper.classList.remove('hidden');
        } else {
          subWrapper.classList.add('hidden');
        }
      }

      // Ensure the hidden/select plan has a valid value after returning from a no-plan variant
      if (planSelect) {
        const hasExisting = !!planSelect.value && Array.from(planSelect.options).some(o => o.value === planSelect.value);
        if (!hasExisting) {
          const firstValid = Array.from(planSelect.options).find(o => o.value);
          if (firstValid) {
            planSelect.value = firstValid.value;
            planSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } else {
      // Hide subscription options and force one-time purchase
      if (subWrapper) subWrapper.classList.add('hidden');
      if (subscrInput) {
        subscrInput.disabled = true;
        if (otpInput && !otpInput.checked) {
          otpInput.checked = true;
          // Fire non-bubbling change so radio-specific listeners run without re-triggering this handler
          otpInput.dispatchEvent(new Event('change'));
        }
      }
      // Clear any plan selection when none are available
      if (planSelect) {
        planSelect.value = '';
        planSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    _igHandlingSubscription = false;
  }

  // Handle initial state
  setTimeout(handleSubscriptionState, 100);

  // Handle variant changes
  productForm.addEventListener('change', handleSubscriptionState);

  // Function to reset volume widget to 1 Set when variant changes
  function resetVolumeWidgetTo1Set() {
    const volumeWidgets = document.querySelectorAll('ig-volume-quantity-widget');
    
    volumeWidgets.forEach(volumeWidget => {
      if (volumeWidget && volumeWidget.hasAttribute('id') && volumeWidget.getAttribute('id').trim() !== '') {
        // Find the 1 Set button and click it
        const oneSetButton = volumeWidget.querySelector('.ig-volume-widget-button[data-quantity="1"]');
        if (oneSetButton) {
          oneSetButton.click();
          igLog('Volume widget reset to 1 Set due to variant change:', volumeWidget);
        }
      }
    });
    
    // Call handleSubscriptionState to ensure subscription availability is updated for new variant
    setTimeout(() => {
      handleSubscriptionState();
    }, 50);
    
    // Update button text based on current subscription state (only once)
    // setTimeout(() => {
    //   const buttonCopy = document.querySelector('.original_label');
    //   const currentPrice = document.querySelector('.title_rating_price .current_price');
    //   const subscrInput = document.querySelector('#subscr');
    //   const isSubscriptionSelected = subscrInput && subscrInput.checked;
      
    //   if (buttonCopy && currentPrice) {
    //     if (isSubscriptionSelected) {
    //       buttonCopy.innerText = 'Subscribe & Save - ' + currentPrice.innerText;
    //     } else {
    //       buttonCopy.innerText = 'Add to cart - ' + currentPrice.innerText;
    //     }
    //   }

    //   // Show strikethrough pricing when resetting to 1 set (variant change)
    //   const wasPriceElements = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
      
    //   if (isSubscriptionSelected) {
    //     // Show strikethrough pricing for 1 set when subscription is selected
    //     wasPriceElements.forEach(el => {
    //       el.style.display = '';
    //       el.classList.remove('hidden');
    //     });
    //   } else {
    //     // Hide strikethrough pricing for 1 set when one-time purchase is selected
    //     wasPriceElements.forEach(el => {
    //       el.style.display = 'none';
    //       el.classList.add('hidden');
    //     });
    //   }
    // }, 200);
  }

  // Track variant changes specifically (not quantity changes)
  let currentVariantId = document.querySelector('.shopify-product-form [name="id"]').value;
  
  // Watch for actual variant ID changes
  const variantInput = document.querySelector('.shopify-product-form [name="id"]');
  if (variantInput) {
    const variantObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          const newVariantId = variantInput.value;
          if (newVariantId !== currentVariantId) {
            currentVariantId = newVariantId;
            igLog('Variant changed from', currentVariantId, 'to', newVariantId);
            
            // Immediately update subscription state for new variant
            setTimeout(() => {
              handleSubscriptionState();
              refreshAddToCartButtonPrice();

              // Update unit prices and compare-at price for widgets and UI based on the new variant
              try {
                const selVariant = findSelectedVariant();
                // If plan select exists and is empty, set to the first valid plan
                const planSelect = document.querySelector('#subscr_select');
                if (planSelect && (!planSelect.value || planSelect.value === '')) {
                  const firstValid = Array.from(planSelect.options).find(o => o.value);
                  if (firstValid) {
                    planSelect.value = firstValid.value;
                    planSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
                const selectedPlanId = document.querySelector('#subscr_select')?.value;
                const oneTimeCents = selVariant?.price || 0;
                let subCents = null;
                if (selVariant && Array.isArray(selVariant.selling_plan_allocations) && selVariant.selling_plan_allocations.length > 0) {
                  const matchedAllocation = selVariant.selling_plan_allocations.find(a => String(a.selling_plan_id) === String(selectedPlanId));
                  subCents = (matchedAllocation || selVariant.selling_plan_allocations[0]).price;
                }
                const compareAtCents = selVariant?.compare_at_price || 0;
                if (window.setVariantUnitPrices) {
                  window.setVariantUnitPrices(oneTimeCents, (subCents ?? oneTimeCents), compareAtCents);
                }
              } catch (e) { igLog('Failed to update prices on variant change', e); }
            }, 50);
            
            // Then reset volume widget
            setTimeout(resetVolumeWidgetTo1Set, 100);
          }
        }
      });
    });
    
    variantObserver.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  // Also listen for swatch changes (for custom swatch implementation)
  document.addEventListener('click', function(event) {
    // Check if a swatch was clicked, but NOT if it's a volume widget button
    if (event.target.matches('.variant-picker__swatches-container label, .swatch-element, .swatch-variant') && 
        !event.target.closest('.ig-volume-widget-button')) {
      setTimeout(() => {
        resetVolumeWidgetTo1Set();
        refreshAddToCartButtonPrice();
      }, 150);
    }
  });

  // Listen for variant-picker custom element changes
  document.addEventListener('change', function(event) {
    if (event.target.closest('variant-picker') && !event.target.closest('.ig-volume-widget-button')) {
      setTimeout(() => {
        resetVolumeWidgetTo1Set();
        refreshAddToCartButtonPrice();
      }, 100);
    }
  });

  var findSelectedVariant = function () {
    var selectedVariantId = parseInt(document.querySelector('.shopify-product-form [name="id"]').value);
    var selectedVariant;

    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === selectedVariantId) {
        selectedVariant = product.variants[i];
        break;
      }
    }

    return selectedVariant;
  }

  // Watch for selling plan option change to update the selected selling plan
  sellingPlanContainer.querySelectorAll('select').forEach(function (optionSelector) {
    optionSelector.addEventListener('change', function () {
      var selectedVariant = findSelectedVariant();
      var availableSellingPlanAllocations = selectedVariant.selling_plan_allocations;
      var selectedSellingPlanId;

      igLog('optionselector', selectedVariant);
      igLog('availableSellingPlanAllocations', availableSellingPlanAllocations);


      // for (var i = 0; i < availableSellingPlanAllocations.length; i++) {
      //   var sellingPlan = availableSellingPlanAllocations[i].selling_plan;
      //   var matchingSellingPlan = false;

      //   // Logic to find matching selling plan

      //   if (matchingSellingPlan) {
      //     selectedSellingPlanId = optionSelector.value;
      //   }
      // }

      igLog('selling plan change ->', optionSelector.value);
      selectedSellingPlanId = optionSelector.value;

      selectedSellingPlanId = (typeof selectedSellingPlanId === 'undefined') ? '' : selectedSellingPlanId;
      sellingPlanCustom.value = selectedSellingPlanId;
    });
  });


  let below_CTA_note_reg = document.querySelector('.below_CTA_note_reg');
  let below_CTA_note_sub = document.querySelector('.below_CTA_note_sub');
  let subscrInput = document.querySelector('#subscr');
  let otpInput = document.querySelector('#one_time');
  let subWrapper = document.querySelector('.subscription_wrapper');



  // Watch for sub option change and update selling plan + other
  sellingPlanContainer.querySelectorAll('[name="purchase_option"]').forEach(function (purchaseOption) {
    purchaseOption.addEventListener('change', function () {
      setTimeout(function() {
        let subCompareAtPrice = document.querySelector('.title_rating_price .was_price');
        let normalPrice = document.querySelector('.title_rating_price .current_price');

        // Derive prices from the currently selected variant (supports variant-specific pricing)
        const selectedVariant = findSelectedVariant();
        const selectedPlanId = document.querySelector('#subscr_select')?.value;
        const oneTimePriceCents = selectedVariant?.price || 0;
        let subscriptionPriceCents = null;
        if (selectedVariant && Array.isArray(selectedVariant.selling_plan_allocations) && selectedVariant.selling_plan_allocations.length > 0) {
          const matchedAllocation = selectedVariant.selling_plan_allocations.find(a => String(a.selling_plan_id) === String(selectedPlanId));
          subscriptionPriceCents = (matchedAllocation || selectedVariant.selling_plan_allocations[0]).price;
        }
        // Display strings
        const oneTimePrice = `$${(oneTimePriceCents / 100).toFixed(2)}`;
        const subPrice = `$${((subscriptionPriceCents ?? oneTimePriceCents) / 100).toFixed(2)}`;

        // Ensure base prices used by the quantity/widget logic are refreshed for the current variant
        if (window.setVariantUnitPrices) {
          const compareAtCents = selectedVariant?.compare_at_price || 0;
          window.setVariantUnitPrices(oneTimePriceCents, (subscriptionPriceCents ?? oneTimePriceCents), compareAtCents);
        }

        // Store the current form state
        const formData = new FormData(purchaseOption.closest('form'));

        // Always check which is checked
        const isSubChecked = subscrInput && subscrInput.checked;
        const isOneTimeChecked = otpInput && otpInput.checked;

        if (isOneTimeChecked) {
          sellingPlanCustom.value = '';
          below_CTA_note_sub.classList.add('hidden');
          below_CTA_note_reg.classList.remove('hidden');
          if (subWrapper) {
            subWrapper.classList.add('hidden');
          }
                      if (!window.abTestWidgetUpdating) {
              normalPrice.innerText = oneTimePrice;
            }
          let compareAtPriceFloat = parseFloat(subCompareAtPrice.innerText.replace('$', ''));
          let currentPrice = document.querySelector('.title_rating_price .current_price');
          let currentPriceFloat = parseFloat(currentPrice.innerText.replace('$', ''));
          if (compareAtPriceFloat == currentPriceFloat) {
            subCompareAtPrice.classList.add('hidden');
          }
          refreshAddToCartButtonPrice();
          
          // Show/hide strikethrough pricing for one-time purchase based on compare_at_price
          const wasPriceElements = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
          const compareAtPriceFloatSafe = parseFloat((subCompareAtPrice?.innerText || '').replace(/[^0-9.]/g, '')) || 0;
          const currentPriceFloatSafe = parseFloat((normalPrice?.innerText || '').replace(/[^0-9.]/g, '')) || 0;
          const shouldShowWas = compareAtPriceFloatSafe > currentPriceFloatSafe && compareAtPriceFloatSafe > 0;
          wasPriceElements.forEach(el => {
            el.style.visibility = shouldShowWas ? 'visible' : 'hidden';
            el.classList.toggle('hidden', !shouldShowWas);
          });
        } else if (isSubChecked) {
          const selectedPlan = document.querySelector('#subscr_select').value;
          sellingPlanCustom.value = selectedPlan;
          below_CTA_note_sub?.classList.remove('hidden');
          below_CTA_note_reg?.classList.add('hidden');
          subCompareAtPrice?.classList.remove('hidden');
          subWrapper?.classList.remove('hidden');
                      if (!window.abTestWidgetUpdating) {
              normalPrice.innerText = subPrice;
            }
          let subPriceFloat = parseFloat(subPrice.replace('$', '')).toFixed(2);
          if (subscrInput) {
            refreshAddToCartButtonPrice(subPrice.replace(/[^0-9.]/g, ''), 'subscribe');
          }
          
          // Show strikethrough pricing for subscription (always discounted)
          const wasPriceElements = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
          wasPriceElements.forEach(el => {
            el.style.visibility = 'visible';
            el.classList.remove('hidden');
          });
        }

        // Dispatch a custom event to notify other handlers
        const event = new CustomEvent('purchase_option_changed', {
          bubbles: true,
          detail: {
            purchaseType: isSubChecked ? 'subscr' : 'one_time',
            sellingPlan: sellingPlanCustom.value
          }
        });
        purchaseOption.dispatchEvent(event);
      }, 0);
    });
  });

  // let subscriptionBlock = document.querySelector('.subscriptionBlock');
  // Only auto-select subscription if the variant supports it
  var selectedVariant = findSelectedVariant();
  var availableSellingPlanAllocations = selectedVariant?.selling_plan_allocations;
  const variantSupportsSubscriptions = availableSellingPlanAllocations && availableSellingPlanAllocations.length > 0;
  
  // Default to ONE-TIME purchase regardless of subscription availability
  if (otpInput) {
    otpInput.click();
  } else if (variantSupportsSubscriptions && subscrInput) {
    subscrInput.click();
  }

  // function getIGTestGroup() {
  //   const TEST_ID = '01515716-132d-437d-b79b-a4a60f2ddc91';
  //   const TEST_GROUP = '15f164c5-5450-46c7-8ae9-4a7375aaadd5';
  //   const CONTROL_GROUP = '15f164c5-5450-46c7-8ae9-4a7375aaadd5';
    
  //   if (!window.igData?.user) return null;
  //   const group = window.igData.user.getTestGroup(TEST_ID);
  //   return group?.id;
  // }

  // Volume Widget functionality
  function handleVolumeWidget() {
  //   // Check for widget presence and content
  //   setTimeout(() => {
  //     if (getIGTestGroup() === '15f164c5-5450-46c7-8ae9-4a7375aaadd5') {
  //       document.querySelector('.purchase-details').classList.add('initialized');
  //     }
  // }, 1000);

    waitForElm('#quantity').then(function(quantityInput) {
      igLog('waitForElm: #quantity input found!', quantityInput);

      let observer;
      let purchaseOptionsArea;
      let isUpdating = false;
      let debounceTimeout = null;

      function updatePurchaseOptionsFromQuantity() {
        if (isUpdating) return;
        isUpdating = true;

        const quantity = parseInt(quantityInput.value, 10);
        const oneTimeInputs = document.querySelectorAll('#one_time');
        const subscrInputs = document.querySelectorAll('#subscr');
        const subscriptionBlocks = document.querySelectorAll('.subscriptionBlock');
        igLog('Quantity field value:', quantity);

        // Always call handleSubscriptionState first to respect variant selling plan availability
        handleSubscriptionState();

        // Get the current variant to check if it supports subscriptions
        var selectedVariant = findSelectedVariant();
        var availableSellingPlanAllocations = selectedVariant?.selling_plan_allocations;
        const variantSupportsSubscriptions = availableSellingPlanAllocations && availableSellingPlanAllocations.length > 0;

        igLog('Selected variant:', selectedVariant?.title || 'Unknown');
        igLog('Variant supports subscriptions:', variantSupportsSubscriptions);

        subscriptionBlocks.forEach(block => block.style.display = '');

        // Handle strikethrough pricing visibility based on quantity
        const wasPriceElements = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
        if (quantity === 1) {
          // Check if subscription is selected
          const subscrInput = document.querySelector('#subscr');
          const isSubscriptionSelected = subscrInput && subscrInput.checked;
          
          if (isSubscriptionSelected) {
            // Show strikethrough pricing for 1 set when subscription is selected
            wasPriceElements.forEach(el => {
              el.style.visibility = 'visible';
              el.classList.remove('hidden');
            });
          } else {
            // Hide strikethrough pricing for 1 set when one-time purchase is selected
            wasPriceElements.forEach(el => {
              el.style.visibility = 'hidden';
              el.classList.add('hidden');
            });
          }
        } else {
          // Hide strikethrough pricing for quantity > 1
          wasPriceElements.forEach(el => {
            el.style.visibility = 'hidden';
            el.classList.add('hidden');
          });
        }

        if (quantity === 1) {
          oneTimeInputs.forEach(input => {
            input.disabled = false;
          });
          
          // Don't override handleSubscriptionState logic - let it handle subscription availability
          // Only enable subscription if variant supports it AND handleSubscriptionState hasn't disabled it
          if (variantSupportsSubscriptions) {
            // Check if handleSubscriptionState has already disabled the subscription input
            const subscrInput = document.querySelector('#subscr');
            if (subscrInput && !subscrInput.disabled) {
              igLog('Quantity = 1: Showing both subscription and one-time purchase options (variant supports subscriptions)');
            } else {
              igLog('Quantity = 1: Subscription disabled by handleSubscriptionState (variant does not support subscriptions)');
            }
          } else {
            igLog('Quantity = 1: Variant does not support subscriptions');
          }
        } else {
          oneTimeInputs.forEach(input => {
            input.checked = true;
            input.disabled = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          
          // For quantity > 1, force one-time purchase but respect variant subscription availability
          if (variantSupportsSubscriptions) {
            subscrInputs.forEach(input => {
              input.checked = false;
              input.disabled = true;
            });
            igLog('Quantity > 1: Forcing one-time purchase, disabling subscription option (variant supports subscriptions)');
          } else {
            // If variant doesn't support subscriptions, keep it disabled (handleSubscriptionState already did this)
            igLog('Quantity > 1: Subscription already disabled (variant does not support subscriptions)');
          }
        }

        isUpdating = false;
        // Do NOT reconnect the observer here!
      }

      // Helper to attach click listeners to volume widget buttons
      function attachVolumeButtonListeners() {

        const volumeButtons = document.querySelectorAll('.ig-volume-widget-button[data-quantity]');
        volumeButtons.forEach(btn => {
          btn.removeEventListener('click', btn._volumeClickHandler);
          btn._volumeClickHandler = function() {
            setTimeout(() => {
              updatePurchaseOptionsFromQuantity();

              // --- Price update logic ---
              const sets = parseInt(btn.getAttribute('data-quantity'), 10);
              // Check if subscription is currently selected
              const subscrInput = document.querySelector('#subscr');
              const isSubscriptionSelected = subscrInput && subscrInput.checked;
              
              // Try to extract price from the button text (e.g., "$25.59 each")
              const priceMatch = btn.textContent.match(/\$([\d,.]+) each/);
              if (sets && priceMatch) {
                const perSetPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
                let displayPrice = perSetPrice;
                
                // If subscription is selected, use subscription price instead of one-time price
                if (isSubscriptionSelected && sets === 1) {
                  const subPriceEl = document.querySelector('.subPrice');
                  if (subPriceEl) {
                    const subPriceText = subPriceEl.innerText;
                    const subPriceMatch = subPriceText.match(/\$([\d,.]+)/);
                    if (subPriceMatch) {
                      displayPrice = parseFloat(subPriceMatch[1].replace(/,/g, ''));
                    }
                  }
                }
                
                const totalPrice = (displayPrice * sets).toFixed(2);

                // Update .purchaseOptionPrice.oneTimePrice
                const oneTimePriceEl = document.querySelector('.purchaseOptionPrice.oneTimePrice');
                if (oneTimePriceEl) {
                  if (sets === 1) {
                    // Revert to original price (from button or from DOM)
                    oneTimePriceEl.textContent = `$${perSetPrice.toFixed(2)}`;
                  } else {
                    oneTimePriceEl.textContent = `$${totalPrice}`;
                  }
                }

                // Update main current price elements
                const currentPriceElements = document.querySelectorAll('.modal_price .current_price, .title_rating_price .current_price');
                currentPriceElements.forEach(el => {
                  if (sets === 1) {
                    // Use appropriate price for 1 set based on subscription state
                    el.textContent = `$${displayPrice.toFixed(2)}`;
                  } else {
                    // Show total price for multiple sets
                    el.textContent = `$${totalPrice}`;
                  }
                });

                // Update .action_button.add_to_cart .original_label
                const addToCartLabel = document.querySelector('.action_button.add_to_cart .original_label');
                if (addToCartLabel) {
                  const upsellTotal = getTotalUpsellPrice();
                  if (sets === 1) {
                    if (isSubscriptionSelected && !isAlwaysAddToCartTemplate()) {
                      // Show "Subscribe & Save" when subscription is selected (unless AB1/AB2 template)
                      addToCartLabel.textContent = `Subscribe & Save - $${(displayPrice + upsellTotal).toFixed(2)}`;
                    } else {
                      // Show "Add to cart" when one-time purchase is selected or on AB1/AB2 template
                      addToCartLabel.textContent = `Add to cart - $${(displayPrice + upsellTotal).toFixed(2)}`;
                    }
                  } else {
                    // For multiple sets, always show "Add to cart" (subscription is disabled for >1 set)
                    addToCartLabel.textContent = `Add to cart - $${(parseFloat(totalPrice) + upsellTotal).toFixed(2)}`;
                  }
                }

                // --- Handle strikethrough pricing visibility ---
                const wasPriceElements = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
                if (sets === 1) {
                  if (isSubscriptionSelected) {
                    // Show strikethrough pricing for 1 set when subscription is selected
                    wasPriceElements.forEach(el => {
                      el.style.visibility = 'visible';
                      el.classList.remove('hidden');
                    });
                  } else {
                    // Hide strikethrough pricing for 1 set when one-time purchase is selected
                    wasPriceElements.forEach(el => {
                      el.style.visibility = 'hidden';
                      el.classList.add('hidden');
                    });
                  }
                } else {
                  // Hide strikethrough pricing for 2, 3, 4 sets
                  wasPriceElements.forEach(el => {
                    el.style.visibility = 'hidden';
                    el.classList.add('hidden');
                  });
                }
              }
              // --- End price update logic ---

            }, 150); // Wait for widget to update DOM
          };
          btn.addEventListener('click', btn._volumeClickHandler);
        });
      }

      // Listen for changes to the quantity input
      quantityInput.addEventListener('change', updatePurchaseOptionsFromQuantity);
      quantityInput.addEventListener('input', updatePurchaseOptionsFromQuantity);

      // Attach click listeners initially
      attachVolumeButtonListeners();

      // Only observe for external DOM changes (e.g., widget re-render)
      purchaseOptionsArea = document.querySelector('.subscriptionBlock')?.parentNode;
      if (purchaseOptionsArea) {
        observer = new MutationObserver((mutationsList) => {
          let relevantChange = false;
          for (const mutation of mutationsList) {
            // Only react if the widget or quantity input was added/removed
            const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
            if (nodes.some(
              node => node.nodeType === 1 && (
                (node.matches && (node.matches('#quantity') || node.matches('.ig-volume-widget-button')))
                || (node.querySelector && (node.querySelector('#quantity') || node.querySelector('.ig-volume-widget-button')))
              )
            )) {
              relevantChange = true;
              break;
            }
          }
          if (relevantChange) {
            if (debounceTimeout) clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
              if (!isUpdating) {
                updatePurchaseOptionsFromQuantity();
                attachVolumeButtonListeners(); // Re-attach click listeners if widget re-rendered
              }
              // Optionally disconnect and reconnect observer to avoid repeated triggers
              observer.disconnect();
              setTimeout(() => {
                observer.observe(purchaseOptionsArea, { childList: true, subtree: true, attributes: false });
              }, 1000);
            }, 200);
          }
        });
        observer.observe(purchaseOptionsArea, { childList: true, subtree: true, attributes: false });
      }

      // Initial check
      setTimeout(updatePurchaseOptionsFromQuantity, 100);
    });
  }

  // Initialize volume widget handler
  // handleVolumeWidget();

});

// Bar Types functionality
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // If on mobile, scroll active pill into view
    if (window.innerWidth <= 768) {
      const activePill = document.querySelector('.bar-type-pill.active');
      if (activePill) {
        setTimeout(() => {
          activePill.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }, 100);
      }
    }
  });
})();

// --- UPSSELL PRICE INTEGRATION ---
function getTotalUpsellPrice() {
  // All upsell items are preselected, so sum all their data-upsell-price attributes
  const upsellItems = document.querySelectorAll('.upsell-offer-item[data-upsell-price]');
  let total = 0;
  upsellItems.forEach(item => {
    const price = parseInt(item.getAttribute('data-upsell-price'), 10);
    if (!isNaN(price)) total += price;
  });
  return total / 100; // convert cents to dollars
}

// Helper function to check if we're on templates that should always show "Add to cart"
function isAlwaysAddToCartTemplate() {
  // LE refill subscription renders the v2 widget on a plain pdp-2026 template
  if (document.querySelector('#abtest-v2-purchase-widget[data-le-subscription="true"]')) return false;

  // Check window._template object (set by Shopify in theme.liquid)
  if (window._template) {
    // Default product template (product.json) has no suffix
    if (!window._template.suffix && window._template.name === 'product') {
      return true;
    }
    // AB1 templates, replo templates, and updated2026 template (but NOT updated2026-abtest, pdp-2026-free-brush, or pdp-2026-free-gift which have their own widget)
    if (window._template.suffix && (window._template.suffix.includes('AB1') || window._template.suffix.toLowerCase().includes('replo') || (window._template.suffix.includes('updated2026') && !window._template.suffix.includes('updated2026-abtest')) || (window._template.suffix.includes('pdp-2026') && !window._template.suffix.includes('pdp-2026-free-brush') && !window._template.suffix.includes('pdp-2026-free-gift') && !window._template.suffix.includes('pdp-2026-sc-sets') /* SC-SETS-2026-10 */))) {
      return true;
    }
  }

  // Fallback checks for older template detection methods
  if (document.body.classList.contains('template-product-updated2026-abtest') ||
      document.body.classList.contains('template-product-pdp-2026-free-brush') ||
      document.body.classList.contains('template-product-pdp-2026-free-gift') ||
      document.body.classList.contains('template-product-pdp-2026-sc-sets') /* SC-SETS-2026-10 */) return false;
  return window.location.pathname.includes('OS20-upd-AB1') ||
         document.body.classList.contains('template-product-os20-upd-ab1') ||
         document.body.classList.contains('template-product-updated2026') ||
         document.querySelector('[data-template*="AB1"]');
}

function updateAddToCartButtonPrice(basePrice, labelType) {
  const addToCartLabel = document.querySelector('.action_button.add_to_cart .original_label');
  if (addToCartLabel) {
    const upsellTotal = getTotalUpsellPrice();
    const finalPrice = (parseFloat(basePrice) + upsellTotal).toFixed(2);
    if (labelType === 'subscribe' && !isAlwaysAddToCartTemplate()) {
      addToCartLabel.textContent = `Subscribe & Save - $${finalPrice}`;
    } else {
      addToCartLabel.textContent = `Add to cart - $${finalPrice}`;
    }
  }
}

function refreshAddToCartButtonPrice() {
  // Get the quantity to ensure we factor it into the price calculation for the button
  const quantityInput = document.querySelector('#quantity, [name="quantity"]');
  const quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
  
  // Trigger the updateQuantityPrices function if it exists (from the quantity handler)
  if (window.updateQuantityPricesHandler) {
    window.updateQuantityPricesHandler();
    return;
  }
  
  // Fallback to original logic - but don't modify .current_price elements
  const buttonCopy = document.querySelector('.original_label');
  const normalPrice = document.querySelector('.title_rating_price .current_price');
  const subscrInput = document.querySelector('#subscr');
  
  if (buttonCopy && normalPrice) {
    // Always use the unit price from .current_price, then multiply by quantity for button only
    const unitPrice = parseFloat(normalPrice.innerText.replace(/[^0-9.]/g, ''));
    const totalPrice = (unitPrice * quantity).toFixed(2);
    
    const labelType = (subscrInput && subscrInput.checked) ? 'subscribe' : 'add';
    updateAddToCartButtonPrice(totalPrice, labelType);
  }
}

// Handle quantity adjustments and price updates
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const quantityInput = document.querySelector('#quantity, [name="quantity"]');
    if (!quantityInput) return;
    
    // Store original prices once
    const oneTimePriceEl = document.querySelector('.oneTimePrice');
    const subPriceEl = document.querySelector('.subPrice');
    if (!oneTimePriceEl || !subPriceEl) return;
    
    const originalPrices = {
      oneTime: parseFloat(oneTimePriceEl.innerText.replace(/[^0-9.]/g, '')),
      subscription: parseFloat(subPriceEl.innerText.replace(/[^0-9.]/g, ''))
    };

    // Expose a setter to update base unit prices when variant changes
    window._igOriginalPrices = originalPrices;
    window.setVariantUnitPrices = function(oneTimeCents, subscriptionCents, compareAtCents) {
      try {
        const qty = parseInt(quantityInput.value) || 1;
        originalPrices.oneTime = (oneTimeCents || 0) / 100;
        originalPrices.subscription = (typeof subscriptionCents === 'number' ? subscriptionCents : oneTimeCents) / 100;

        // Update widget display totals
        if (oneTimePriceEl) oneTimePriceEl.innerText = `$${(originalPrices.oneTime * qty).toFixed(2)}`;
        if (subPriceEl) subPriceEl.innerText = `$${(originalPrices.subscription * qty).toFixed(2)}`;

        // Update unit price at top based on current purchase option
        const normalPriceEl = document.querySelector('.title_rating_price .current_price');
        const isSub = document.querySelector('#subscr')?.checked;
        if (normalPriceEl) {
          normalPriceEl.innerText = `$${(isSub ? originalPrices.subscription : originalPrices.oneTime).toFixed(2)}`;
        }

        // Update compare at price visibility and value
        const wasPriceEls = document.querySelectorAll('.modal_price .was_price, .title_rating_price .was_price');
        const selectedUnitCents = (isSub ? (subscriptionCents ?? oneTimeCents) : oneTimeCents) || 0;
        let wasCentsToShow = compareAtCents || 0;
        let shouldShowWas = false;
        if (isSub) {
          // For subscription, always show a reference price: prefer compare_at, fallback to one-time price
          wasCentsToShow = (compareAtCents && compareAtCents > 0) ? compareAtCents : oneTimeCents;
          shouldShowWas = true;
        } else {
          // For one-time, only show if compare_at is a real markdown
          shouldShowWas = (compareAtCents || 0) > oneTimeCents && (compareAtCents || 0) > 0;
          wasCentsToShow = compareAtCents || 0;
        }
        wasPriceEls.forEach(el => {
          if (wasCentsToShow > 0) {
            var formattedPrice = '$' + (wasCentsToShow / 100).toFixed(2);
            if (typeof updateAccessibleStrikePrice === 'function') {
              updateAccessibleStrikePrice(el, formattedPrice, shouldShowWas);
            } else {
              // Fallback if function not available
              el.innerText = formattedPrice;
              el.style.visibility = shouldShowWas ? 'visible' : 'hidden';
              el.classList.toggle('hidden', !shouldShowWas);
            }
          } else {
            if (typeof updateAccessibleStrikePrice === 'function') {
              updateAccessibleStrikePrice(el, null, false);
            } else {
              el.style.visibility = 'hidden';
              el.classList.add('hidden');
            }
          }
        });

        // Recompute totals elsewhere
        if (typeof window.updateQuantityPricesHandler === 'function') {
          window.updateQuantityPricesHandler();
        }
        refreshAddToCartButtonPrice();
      } catch (e) {
        console.warn('setVariantUnitPrices failed', e);
      }
    };
    
    function updateQuantityPrices() {
      const quantity = parseInt(quantityInput.value) || 1;
      const isSubscriptionSelected = document.querySelector('#subscr')?.checked;
      
      // Update widget prices (these should show total for quantity)
      oneTimePriceEl.innerText = `$${(originalPrices.oneTime * quantity).toFixed(2)}`;
      subPriceEl.innerText = `$${(originalPrices.subscription * quantity).toFixed(2)}`;
      
      // DO NOT update .current_price elements - they should always show unit price
      
      // Update button price (this should show total for quantity)
      const addToCartLabel = document.querySelector('.action_button.add_to_cart .original_label');
      if (addToCartLabel) {
        const displayPrice = isSubscriptionSelected ? originalPrices.subscription : originalPrices.oneTime;
        const finalPrice = ((displayPrice * quantity) + getTotalUpsellPrice()).toFixed(2);
        addToCartLabel.textContent = `${isSubscriptionSelected && !isAlwaysAddToCartTemplate() ? 'Subscribe & Save' : 'Add to cart'} - $${finalPrice}`;
      }
    }
    
    // Expose this function globally so refreshAddToCartButtonPrice can use it
    window.updateQuantityPricesHandler = updateQuantityPrices;
    
    // Event listeners
    quantityInput.addEventListener('input', updateQuantityPrices);
    quantityInput.addEventListener('change', updateQuantityPrices);
    document.addEventListener('click', (e) => e.target.closest('.js-change-quantity') && setTimeout(updateQuantityPrices, 100));
    document.querySelectorAll('[name="purchase_option"]').forEach(opt => opt.addEventListener('change', updateQuantityPrices));
    document.querySelectorAll('.ab-test-quantity-radio').forEach(radio => radio.addEventListener('change', () => setTimeout(updateQuantityPrices, 100)));
    
    updateQuantityPrices(); // Initial update
  }, 600);
});


// New accordion component fallback (<accordion-disclosure>)
;(function() {
  // Only define the new component; legacy accordions are handled elsewhere
  if (window.customElements && !window.customElements.get('accordion-disclosure')) {
    try {
      window.customElements.define('accordion-disclosure', class extends HTMLElement {
        connectedCallback(){
          if (this._igAccordionInitialized) {
            // Avoid rebinding listeners on reconnects
            return;
          }
          this._igAccordionInitialized = true;
          
          var details = this.querySelector('details');
          var summary = details && details.querySelector('summary');
          var content = details && details.querySelector('.ig-accordion__content, .accordion__content');
          if (!details || !summary || !content) return;

          function setAria(open){ details.setAttribute('aria-expanded', open ? 'true' : 'false'); }

          function openAccordion(){
            if (!details.hasAttribute('open')) details.setAttribute('open','');
            setAria(true);
            details._igClosing = false;
            // Measure final height and animate to it, then release height to avoid clipping
            var h = (content.firstElementChild || content).scrollHeight;
            content.style.maxHeight = h + 'px';
            content.style.opacity = '1';
            var released = false;
            var release = function(){
              if (released) return;
              released = true;
              content.removeEventListener('transitionend', onOpened);
              if (clearReleaseTimer) clearTimeout(clearReleaseTimer);
              if (details.hasAttribute('open') && !details._igClosing) {
                // Allow dynamic inner growth (nested accordions expanding) after animation completes
                content.style.maxHeight = 'none';
              }
            };
            var onOpened = function(e){
              if (e.target !== content) return;
              if (e.propertyName !== 'max-height') return;
              release();
            };
            content.addEventListener('transitionend', onOpened);
            var clearReleaseTimer = setTimeout(release, 450);
          }

          function closeAccordion(){
            // Reflect intent to close immediately for faster icon change
            setAria(false);
            // Mark as closing so subsequent taps see it as closed even before the attribute flips
            details._igClosing = true;
            // If height was released to 'none', fix it to current height before collapsing
            if (content.style.maxHeight === '' || content.style.maxHeight === 'none') {
              var fixH = (content.firstElementChild || content).scrollHeight;
              content.style.maxHeight = fixH + 'px';
              // force reflow so the browser acknowledges the fixed height before transition
              void content.offsetHeight;
            }
            var h = (content.firstElementChild || content).scrollHeight;
            content.style.maxHeight = h + 'px';
            content.style.opacity = '1';
            requestAnimationFrame(function(){
              content.style.maxHeight = '0px';
              content.style.opacity = '0';
            });
            var closed = false;
            var finalize = function(){
              if (closed) return;
              closed = true;
              content.removeEventListener('transitionend', done);
              if (closeTimer) clearTimeout(closeTimer);
              details.removeAttribute('open');
              details._igClosing = false;
            };
            var done = function(e){
              if (e.target !== content) return;
              if (e.propertyName !== 'max-height') return;
              finalize();
            };
            content.addEventListener('transitionend', done);
            var closeTimer = setTimeout(finalize, 450);
          }

          // Intercept click/keyboard to animate close smoothly
          var _lastToggleAt = 0;
          function shouldThrottleToggle(){
            var now = Date.now();
            if (now - _lastToggleAt < 250) return true;
            _lastToggleAt = now;
            return false;
          }
          summary.addEventListener('click', function(ev){
            ev.preventDefault();
            if (shouldThrottleToggle()) {
              
              return;
            }
            var isOpen = details.hasAttribute('open') && !details._igClosing;
            
            if (isOpen) { closeAccordion(); } else { openAccordion(); }
          });
          summary.addEventListener('keydown', function(ev){
            // Let the native synthesized click handle the toggle to avoid double toggles.
            // Prevent scrolling on Space, and optionally on Enter for consistency across browsers.
            if (ev.key === ' ' || ev.key === 'Spacebar') ev.preventDefault();
            if (ev.key === 'Enter') {
              // Do not toggle here; a click will follow.
            }
          });

          // Optional: If programmatically toggled elsewhere, you can sync by dispatching a custom event

          // Initial state
          setTimeout(function(){
            if (details.hasAttribute('open')) openAccordion();
            else { setAria(false); content.style.maxHeight = '0px'; content.style.opacity = '0'; }
          },0);
        }
      });
    } catch(e) {}
  }
})();
